/**
 * The one pale tint per exposure filter, shared by the counter cards and the row exposure badge
 * so the colour language is the same in both places (prototype variant C1, spec 6.2).
 *
 * Class strings are written out in full rather than composed, because Tailwind's scanner only
 * sees literals.
 */
import type { ExposureFilter } from "../exposedSensitiveDocuments";

export interface ExposureTone {
  /** Who can open a document of this kind: the counter card's "Accessible by" line. */
  accessibleBy: string;
  /** The active counter card. */
  selected: string;
  /** Hover on an inactive counter card. */
  hover: string;
  /** The row badge. */
  badge: string;
  /** The status dot, in both places. */
  dot: string;
}

export const EXPOSURE_TONE: Record<ExposureFilter, ExposureTone> = {
  public: {
    accessibleBy: "anyone with the link",
    selected: "bg-rose-50 text-rose-900 border-rose-300 ring-1 ring-rose-200",
    hover: "hover:bg-rose-50/60 hover:border-rose-200",
    badge: "bg-rose-50 text-rose-800 border-rose-200",
    dot: "bg-rose-500",
  },
  external: {
    accessibleBy: "people outside the organisation",
    selected: "bg-amber-50 text-amber-900 border-amber-300 ring-1 ring-amber-200",
    hover: "hover:bg-amber-50/60 hover:border-amber-200",
    badge: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  both: {
    accessibleBy: "anyone with the link and people outside the organisation",
    selected: "bg-violet-50 text-violet-900 border-violet-300 ring-1 ring-violet-200",
    hover: "hover:bg-violet-50/60 hover:border-violet-200",
    badge: "bg-violet-50 text-violet-800 border-violet-200",
    dot: "bg-violet-500",
  },
};

/** The order the counter strip renders in. */
export const EXPOSURE_FILTERS: ExposureFilter[] = ["public", "external", "both"];
